<template>
  <div class="x_box">
    <ol class="breadcrumb x_breadcrumb">
      <li class="breadcrumb-item active" aria-current="page">{{ $t("setting") }}</li>
    </ol>
    <div class="x_header">
      <button
        type="button"
        class="btn btn-outline-primary btn-sm no-bor"
        @click="$router.go(-1)"
      >
        <i class="fa fa-arrow-circle-o-left"></i> {{ $t("back") }}
      </button>
    </div>
    <div class="x_body">
      <div class="card x_card">
        <div class="card-body">
          <div class="row">
            <div class="col-sm-4">
              <table class="table table-condensed">
                <tbody>
                  <tr>
                    <td style="width: 120px">{{ $t("display_name") }}</td>
                    <td>{{ $store.state.auth.DisplayName }}</td>
                  </tr>
                  <tr>
                    <td style="width: 150px">{{ $t("user_type") }}</td>
                    <td>{{ auth.UserTypeId == 2 ? "Client" : "User" }}</td>
                  </tr>
                  <tr>
                    <td style="width: 150px">{{ $t("language") }}</td>
                    <td>
                      <select
                        class="form-control form-control-sm"
                        v-model="lang"
                        @change="changeLang"
                      >
                        <option value="en">{{ $t("lang_english") }}</option>
                        <option value="kh">{{ $t("lang_khmer") }}</option>
                      </select>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- <pre>{{ $store.state.auth }}</pre> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data: function () {
    return {
      lang: "en",
    };
  },
  created: function () {
    this.lang = this.auth.Language;
  },
  methods: {
    changeLang() {
      let loading = this.$loading.show();
      this.$api()
        .post("user/change-language", { Language: this.lang })
        .then((res) => {
          if (this.$isValid(res)) {
            this.$i18n.locale = this.lang;
          }
        })
        .finally(() => loading.hide());
    },
  },
  computed: {
    auth() {
      return this.$store.state.auth;
    },
  },
};
</script>
